var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70833 13.4586C8.70833 13.8958 9.06276 14.2502 9.5 14.2502C9.93724 14.2502 10.2917 13.8958 10.2917 13.4586L10.2917 7.50744L12.8877 10.2073C13.1907 10.5225 13.6919 10.5323 14.007 10.2292C14.3222 9.92619 14.332 9.42504 14.029 9.10987L10.0706 4.99321C9.9214 4.83796 9.71533 4.75024 9.5 4.75024C9.28467 4.75024 9.0786 4.83796 8.92937 4.99321L4.97103 9.10986C4.66798 9.42503 4.6778 9.92619 4.99296 10.2292C5.30812 10.5323 5.80925 10.5225 6.1123 10.2073L8.70833 7.50744L8.70833 13.4586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 7.12508C17.4167 7.56231 17.7711 7.91675 18.2083 7.91675C18.6456 7.91675 19 7.56231 19 7.12508L19 2.37508C19 1.06337 17.9367 8.16846e-05 16.625 8.15699e-05L2.375 8.03242e-05C1.06329 8.02095e-05 1.22304e-07 1.06337 7.6307e-09 2.37508L-4.07627e-07 7.12508C-4.45851e-07 7.56231 0.354429 7.91675 0.791666 7.91675C1.2289 7.91675 1.58333 7.56231 1.58333 7.12508L1.58333 2.37508C1.58333 1.93784 1.93776 1.58341 2.375 1.58341L16.625 1.58341C17.0622 1.58341 17.4167 1.93784 17.4167 2.37508L17.4167 7.12508Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.7f15e6f1.svg";
export { ForwardRef as ReactComponent };